import { Col, Row } from 'antd';
import { Button, ButtonFilter } from 'components';
import React, { useEffect, useRef, useState } from 'react';
import { FilterUserPage, TableUserPage } from 'pages';
import ModalCreateUser from './ModalCreateUser';
import { icons } from 'utils/constants/icons';
import { dataTable } from 'mock/data';
import { useTitle } from 'contexts/TitleProvider';
import path from 'routes/Path';

const { PlusOutlined } = icons;

const UserPage = () => {
  const childRef = useRef<any>(null);
  const [isOpenFilter, setIsOpenFilter] = useState(false);
  const [isOpenModalCreate, setIsOpenModalCreate] = useState(false);
  const [dataUser, setDataUser] = useState(dataTable);
  const [edit, setEdit] = useState(false);
  const { setTitle, setBreadcrumb } = useTitle();

  useEffect(() => {
    setTitle('Người dùng');
    setBreadcrumb([
      { title: 'Hệ thống', href: path.HO_PLAN },
      { title: 'Người dùng' },
    ]);
  }, [setBreadcrumb, setTitle]);

  const handleAndRow = async () => {
    if (childRef && childRef.current) {
      childRef.current.handleeAddRow();
    }
  };
  return (
    <>
      <Row gutter={[8, 16]} align={'middle'} justify={'end'}>
        <Col>
          <Button
            iconBefore={<PlusOutlined />}
            // handleOnclick={() => setIsOpenModalCreate((prev) => !prev)}
            title="Tạo tài khoản"
            disabled={edit}
            handleOnclick={handleAndRow}
          />
        </Col>
        <Col>
          <ButtonFilter isOpen={isOpenFilter} setIsOpen={setIsOpenFilter} />
        </Col>
      </Row>
      {isOpenFilter && <FilterUserPage />}
      <TableUserPage
        data={dataUser}
        setData={setDataUser}
        edit={edit}
        setEdit={setEdit}
        ref={childRef}
      />
      <ModalCreateUser
        open={isOpenModalCreate}
        setOpen={setIsOpenModalCreate}
      />
    </>
  );
};

export default UserPage;
